export const TypeBlueprint = {
  LLM: 'LLM',
} as const;